import React, { useEffect, useState } from 'react';
import { Odd } from '../../../../models/Odd_response_model.tsx';
import { BetDetails } from '../../../../models/MyBetModel.tsx';
import { MdKeyboardArrowDown } from "react-icons/md";
import { GrFormClose } from "react-icons/gr";
import { useBetContext } from '../../../../context/BetContext.tsx';
import { formatNumbersInLabel, formatSpecialtyMarketLabel, getBetSpecialtyMarketLabel } from '../../../../helpers/functions.tsx';
import BetLogo from '../BetLogo.tsx';
import { BetSlipTrashButton, SlipPickMarket, SlipPickStakes } from '../BetSlipChrome.tsx';
interface IOddFuture {
    bet: BetDetails
}

const OddFuture = (props: IOddFuture) => {

    const { bet } = props;
    const { updateBet, deleteBet } = useBetContext();
    const [stake, setStake] = useState(bet.bet);
    const [profit, setProfit] = useState(bet.reward ?? 0)
    const [showLeagueDetails, setShowLeagueDetails] = useState(false);

    useEffect(() => {
        if (!bet) return;

        setStake(bet.bet ?? 0);
        setProfit(bet.reward ?? 0);
    }, [bet]);

    useEffect(() => {
        const updatedBet: BetDetails = { ...bet, bet: stake, reward: profit };
        if (stake !== bet.bet || profit !== bet.reward) {
            updateBet(updatedBet);
        }
    }, [stake, profit]);


    const _calcProfit = (stake: number, odd?: Odd) => {
        const price = odd?.price ?? bet.odd?.price;

        if (!price) return 0;

        const profit =
            price > 0
                ? stake * (price / 100)
                : (stake * 100) / Math.abs(price);

        return Math.round(profit);
    };

    const _calcStake = (profit: number, odd?: Odd) => {
        const price = odd?.price ?? bet.odd?.price;

        if (!price) return 0;

        const stake =
            price > 0
                ? (profit * 100) / price
                : (profit * Math.abs(price)) / 100;

        return Math.round(stake);
    };

    const updateProfit = (e: any) => {
        const newProfit = parseFloat(e.target.value);

        if (isNaN(newProfit) || newProfit < 0) {
            setProfit(0);
            setStake(0);
            return;
        }

        setProfit(Math.round(newProfit));
        setStake(_calcStake(newProfit));
    };

    const updateStake = (e: any) => {
        const newStake = parseFloat(e.target.value);

        if (isNaN(newStake) || newStake < 0) {
            setStake(0);
            setProfit(0);
            return;
        }

        setStake(Math.round(newStake));
        setProfit(_calcProfit(newStake));
    };

    const toggleLeagueDetails = () => {
        setShowLeagueDetails(prevState => !prevState);
    };

    const formatNumber = (num: number) => {
        return num > 0 ? `+${num}` : `${num}`;
    };

    return (
        <>
            <div className="slip-pick">
                <div className='league' onClick={toggleLeagueDetails}>
                    <div className='centerModal'>
                        <span className='bet-text-league'>{bet.league}</span>
                    </div>
                    <div className='centerModal'>
                        {showLeagueDetails ? <GrFormClose className='icon-modal' /> : <MdKeyboardArrowDown className='icon-modal' />}
                    </div>
                </div>

                <div>
                    <div className={`game-team ${showLeagueDetails ? 'no-border' : ''}`}>
                        <div className='centerModal slip-pick__team'>
                            <BetLogo bet={bet} className="sport-logos-modal" alt="" />
                            <div className="slip-pick__meta">
                                <span className='bet-text-league'>
                                    <span className='text-bet-small'>YOUR BET IN:</span> {formatNumbersInLabel(bet.betName)}
                                    {bet?.gameType?.toLowerCase().includes("live") && (
                                        <span className="live-bet-label"> (Live)<span className="live-text-dot" aria-hidden="true" /></span>
                                    )}
                                </span>
                                <SlipPickMarket label={getBetSpecialtyMarketLabel(bet) || formatSpecialtyMarketLabel(bet.marketName)} />
                            </div>
                        </div>
                        <div className='centerModal slip-pick__odds-wrap'>
                            <span className='price show-modal'>Buy Points</span>
                            <span className="slip-odd-stepper slip-odd-stepper--static">
                                {formatNumber(bet.odd.price)}
                            </span>
                            <BetSlipTrashButton onClick={() => deleteBet(bet)} />
                        </div>
                    </div>
                    {showLeagueDetails && (
                        <div className="league-details">
                            {/* <span className='details-bet'><span className='details-bet-title'>Scheduled : </span>{bet.gameId}</span>
                            <span className='details-bet'><span className='details-bet-title'>Selection : </span>{bet.}</span> */}
                        </div>
                    )}
                </div>

                <SlipPickStakes
                    stake={stake || ''}
                    profit={profit || ''}
                    onStakeChange={updateStake}
                    onProfitChange={updateProfit}
                    onDelete={() => deleteBet(bet)}
                />

            </div>
        </>
    );
};

export default OddFuture